import { ActiveProposalsPanel } from '../components/active-proposals-panel/ActiveProposalsPanel'
import {
  MyVotingPowerSidePanel,
  MyVotingPowerSidePanelProps,
} from '../components/my-voting-power-side-panel/MyVotingPowerSidePanel'
import {
  VotingPowerDelegationPanel,
  VotingPowerDelegationPanelProps,
} from '../components/voting-power-delegation-panel/VotingPowerDelegationPanel'
import { Proposal } from '../types'
import { PageLayout } from '@/ui/layouts/PageLayout'

export interface SpkGovernanceViewProps {
  proposals: Proposal[]
  votingPowerDelegationPanelProps: VotingPowerDelegationPanelProps
  myVotingPowerSidePanelProps: MyVotingPowerSidePanelProps
}

export function SpkGovernanceView({
  proposals,
  votingPowerDelegationPanelProps,
  myVotingPowerSidePanelProps,
}: SpkGovernanceViewProps) {
  return (
    <PageLayout>
      <h1 className="typography-heading-1">Spark Governance</h1>
      <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-[11fr_5fr]">
        <div className="grid grid-cols-1 gap-5">
          <VotingPowerDelegationPanel {...votingPowerDelegationPanelProps} />
          <ActiveProposalsPanel proposals={proposals} />
        </div>
        <MyVotingPowerSidePanel {...myVotingPowerSidePanelProps} />
      </div>
    </PageLayout>
  )
}
